<h2 class="section-title">{{ 'settings.period.periodDetail' | translate }}</h2>
<form [formGroup]="periodForm" (ngSubmit)="save()">
    <div class="card form-grid">
        <div class="form-field">
            <label for="yearInput" class="form-field__label form-field__label--required">
                {{ 'components.settingList.period' | translate }}
            </label>
            <p-select
                inputId="yearInput"
                [options]="yearInDropdown"
                formControlName="year"
                [placeholder]="'components.settingsForm.companySection.firstMeasureYear.placeholder' | translate"
                [emptyFilterMessage]="'common.filter.empty' | translate"
                appendTo="body" />
            @if (periodForm.get('year')?.errors?.required && periodForm.get('year')?.touched) {
                <small class="p-error">{{ 'common.forms.validationMessages.required' | translate }}</small>
            }
        </div>
    </div>
    <div class="form-actions">
        @if (period !== null && (questionnaires?.length ?? 0 > 1)) {
            <p-button
                class="form-actions__start"
                severity="danger"
                [text]="true"
                icon="ms ms-delete"
                [label]="'components.settingsForm.button.remove' | translate"
                (onClick)="onDelete()" />
        }
        <p-button severity="secondary" [label]="'advancedMeasure.form.cancel' | translate" (onClick)="close()" />
        <p-button type="submit" [label]="'common.confirm_button' | translate" />
    </div>
</form>
<p-confirmDialog />
